import { Colors } from '@sigma-frontend-libs/commons'

import { icons } from '@/utils'

import sticker from '@/components/sticker'

export default function(h) {
  return h(
    sticker,
    {
      props: {
        value: this.$_value,
        label: this.$_label,
        icon: icons.wallet,
        color: Colors.grey,
        minWidth: 120,
        button: {
          icon: icons.refresh,
          color: Colors.grey,
          loading: this.balanceLoading,
          disabled: this.balanceLoading,
          callback: () => {
            return this.getBalance()
          }
        }
      }
    }
  )
}
